import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    message: "Welcome to Dashboard",
  },
  getters: {

  },
  mutations: {
    // response(state) {
    //   state = 'How may I help you?'
    // }
  },
  actions: {
    async fetchAIResponse() {
      // context.commit('response')
      // alert('danjksn')
    }
  },
  modules: {
  }
})
